import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { useToasts } from '../../lib/toast';
import type { PartnerRow } from '@taj/types';

export function PartnersManager({ onBack }: { onBack: () => void }) {
  const push = useToasts((s) => s.push);
  const [partners, setPartners] = useState<PartnerRow[]>([]);
  const [edits, setEdits] = useState<Record<string, { type: string; comm: string }>>({});
  const [name, setName] = useState('');
  const [comm, setComm] = useState('');

  const load = () => api.listPartners().then((list) => {
    setPartners(list);
    const e: Record<string, { type: string; comm: string }> = {};
    list.forEach((p) => { e[p.id] = { type: p.type, comm: String(p.commissionPct) }; });
    setEdits(e);
  }).catch((err) => push(err.message, 'warn'));
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  const add = async () => {
    if (!name.trim()) return;
    try {
      await api.createPartner({ type: name.trim(), commissionPct: parseFloat(comm.replace(',', '.')) || 0 });
      setName(''); setComm('');
      load();
    } catch (e: any) { push(e.message, 'warn'); }
  };

  const setE = (id: string, patch: Partial<{ type: string; comm: string }>) => setEdits((s) => ({ ...s, [id]: { ...s[id], ...patch } }));
  const saveRow = (id: string) => {
    const e = edits[id];
    api.updatePartner(id, { type: e.type.trim(), commissionPct: parseFloat(e.comm.replace(',', '.')) || 0 })
      .then(() => push('✅ Partenaire enregistré')).catch((err) => push(err.message, 'warn'));
  };
  const toggleActive = (p: PartnerRow) => {
    const v = !p.active;
    setPartners((l) => l.map((x) => (x.id === p.id ? { ...x, active: v } : x)));
    api.updatePartner(p.id, { active: v }).catch((err) => push(err.message, 'warn'));
  };
  const remove = async (id: string) => {
    if (!confirm('Supprimer ce partenaire ?')) return;
    try { await api.deletePartner(id); setPartners((l) => l.filter((x) => x.id !== id)); } catch (e: any) { push(e.message, 'warn'); }
  };

  return (
    <div className="staff-scroll">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '4px 0 14px' }}>
        <button className="km-back" onClick={onBack}>←</button>
        <div className="staff-title" style={{ fontSize: '1.4rem', flex: 1 }}>🤝 Partenaires de livraison</div>
      </div>

      <div className="cc" style={{ maxWidth: 640 }}>
        <div style={{ fontSize: '.82rem', color: 'var(--ink-faint)', marginBottom: 12 }}>
          Ajoute tes plateformes (Uber Eats, Deliveroo, Just Eat…) et leur <b>commission (%)</b>. Le CA et la
          commission par partenaire s'afficheront dans <b>Manager → Partenaires</b>.
        </div>

        {/* Ajout */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 14 }}>
          <input className="inp" style={{ flex: '2 1 180px' }} placeholder="Nom (ex. Uber Eats)" value={name}
            onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} />
          <input className="inp" inputMode="decimal" style={{ width: 110 }} placeholder="Commission %" value={comm}
            onChange={(e) => setComm(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} />
          <button className="btn-gold" style={{ width: 'auto', padding: '11px 16px' }} onClick={add}>＋ Ajouter</button>
        </div>

        {partners.length === 0 && <div style={{ fontSize: '.85rem', color: 'var(--ink-faint)' }}>Aucun partenaire. Ajoute Uber Eats, Deliveroo… ci-dessus.</div>}
        {partners.map((p) => {
          const e = edits[p.id];
          if (!e) return null;
          return (
            <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 0', borderBottom: '1px solid var(--line)', flexWrap: 'wrap', opacity: p.active ? 1 : 0.5 }}>
              <input className="inp" style={{ flex: '2 1 150px', minWidth: 130, fontWeight: 700 }} value={e.type}
                onChange={(ev) => setE(p.id, { type: ev.target.value })} onBlur={() => saveRow(p.id)} />
              <input className="inp" inputMode="decimal" style={{ width: 84 }} value={e.comm}
                onChange={(ev) => setE(p.id, { comm: ev.target.value })} onBlur={() => saveRow(p.id)} />
              <span style={{ color: 'var(--ink-dim)', fontWeight: 700 }}>%</span>
              <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '.76rem', fontWeight: 700, color: 'var(--ink-dim)' }}>
                <input type="checkbox" checked={p.active} onChange={() => toggleActive(p)} /> Actif
              </label>
              <button type="button" title="Supprimer" onClick={() => remove(p.id)}
                style={{ marginLeft: 'auto', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '1.05rem' }}>🗑️</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
